const state = {
  pickLocations:{}
}

export default state
